import { Tooltip } from '@mui/material'
import type { ReactNode } from 'react'
import { dynamicClassName } from 'styles/helper'

import styles from './NewSwitch.module.less'

type TabItem = {
  value: string
  label: string
  tooltip?: string
}

type NewSwitchProps = {
  items: TabItem[]
  value?: string
  setNoTabActive?: boolean
  disabled?: boolean
  size?: 'default' | 'compact'
  onClick: (value: string) => void
  variant?: 'default' | 'lighter'
}

export default function NewSwitch({
  items = [],
  value,
  setNoTabActive = false,
  disabled = false,
  size = 'default',
  onClick,
  variant = 'default',
}: NewSwitchProps): ReactNode {
  if (items.length === 0) {
    return null
  }

  return (
    <div
      className={dynamicClassName({
        [styles.SwitchGroup]: true,
        [styles.SwitchGroup__compact]: size === 'compact',
        [styles.SwitchGroup__lighter]: variant === 'lighter',
      })}
    >
      {items.map((item, index) => {
        const isActive = !setNoTabActive && item.value === value
        const button = (
          <button
            type="button"
            key={item.value}
            aria-pressed={isActive}
            disabled={disabled}
            className={dynamicClassName({
              [styles.SwitchGroup_Switch]: true,
              [styles.SwitchGroup_Switch__firstElement]: index === 0,
              [styles.SwitchGroup_Switch__lastElement]: index === items.length - 1,
              [styles.SwitchGroup_Switch__active]: isActive && !disabled,
              [styles.SwitchGroup_Switch__disabled]: disabled,
            })}
            onClick={() => onClick(item.value)}
          >
            <div
              className={dynamicClassName({
                [styles.SwitchGroup_Switch_Title]: true,
                [styles.SwitchGroup_Switch_Title__active]: isActive,
                [styles.SwitchGroup_Switch_Title__disabled]: disabled,
              })}
            >
              {item.label}
            </div>
          </button>
        )

        if (!item.tooltip) {
          return button
        }

        return (
          <Tooltip key={item.value} title={item.tooltip} arrow describeChild>
            {disabled ? <span className={styles.SwitchGroup_TooltipWrapper}>{button}</span> : button}
          </Tooltip>
        )
      })}
    </div>
  )
}
